import React, {useContext, useState} from 'react';
import {update} from "../Sites/api";
import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";
import {ArraySettings} from "./ArraySettings";
import {makeStyles} from "@mui/styles";
import {store} from "../store";
import {Box, Button, Dialog, DialogContent, DialogTitle, Typography} from '@mui/material';
import HotelOutlined from '@mui/icons-material/HotelOutlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import {eventColourPalette, getEventTypeColour} from '../Events/eventTypeColours';

const useStyles = makeStyles({
  alert:{
    marginBottom: '30px'
  }
});

export const EventTypes = () => {
  const {state, dispatch} = useContext(store);
  const classes = useStyles();
  const [submitFailed, setSubmitFailed] = useState(false);
  const [colourType, setColourType] = useState(null);
  const [saving, setSaving] = useState(false);
  const [previewColour, setPreviewColour] = useState('#ffffff');

  const updateSite = (values) => {
    setSubmitFailed(false);
    return update(state.site._id, values).then(data => {
      dispatch({ type: 'update site', payload: data.data });
      return true;
    }).catch(() => {
      setSubmitFailed(true);
      return false;
    });
  };

  const saveColour = async () => {
    setSaving(true);
    const colours = (state.site.eventTypeColours || []).filter(item => item.eventType !== colourType);
    const saved = await updateSite({eventTypeColours: [...colours, {eventType: colourType, colour: previewColour}]});
    setSaving(false);
    if (saved) setColourType(null);
  };

  return (
    <div>
      {submitFailed ? <Alert severity="error" className={classes.alert}>Failed to update site.</Alert> : null}
      <Paper className="my-paper">
        {state.site.name ?
          <div>
            <ArraySettings sites={state.site} updateSite={updateSite} property={'eventTypes'} label={'Event Types'}
              getChipProps={eventType => ({
                title: `Choose colour for ${eventType}`,
                sx: {backgroundColor: getEventTypeColour(state.site, eventType), border: '1px solid #ccc'},
                onClick: () => {
                  setPreviewColour(getEventTypeColour(state.site, eventType));
                  setColourType(eventType);
                }
              })} />
            <Typography variant="caption" color="text.secondary">Click an event type to choose its background colour.</Typography>
            <ArraySettings sites={state.site} updateSite={updateSite} property={'teamAssociations'} label={'Team Associations'} />
            <ArraySettings sites={state.site} updateSite={updateSite} property={'positions'} label={'Positions'} />
          </div> : null}
      </Paper>
      <Dialog open={colourType !== null} onClose={() => {if (!saving) setColourType(null);}} maxWidth="xs" fullWidth>
        <DialogTitle>Colour for {colourType}</DialogTitle>
        <DialogContent>
          <Box role="group" aria-label="Event background colours" sx={{display: 'flex', flexWrap: 'wrap', gap: 1, py: 1}}>
            {eventColourPalette.map(({name, colour}) => <Button key={colour} aria-label={name} title={name}
              aria-pressed={previewColour === colour} disabled={saving} onClick={() => setPreviewColour(colour)}
              sx={{minWidth: 40, width: 40, height: 40, bgcolor: colour,
                border: previewColour === colour ? '2px solid' : '1px solid #ccc', borderColor: previewColour === colour ? 'primary.main' : '#ccc',
                '&:hover': {bgcolor: colour, outline: '2px solid #aaa'}}} />)}
          </Box>
          <Box sx={{bgcolor: previewColour, color: '#333', border: '1px solid #ccc', p: 1, my: 2}}>
            <Typography variant="body2">Example event</Typography>
            <Typography sx={{fontSize: 11, color: '#666'}}><b style={{color: '#2e7d32'}}>3:00PM</b> · {colourType}</Typography>
            <Box sx={{display: 'flex', gap: 1, alignItems: 'center', color: '#666', fontSize: 11, mt: 1}}>
              <HotelOutlined fontSize="small" /> 12 <PersonOutlineOutlined fontSize="small" /> 30
            </Box>
          </Box>
          {submitFailed && <Alert severity="error">Unable to save the colour. Please try again.</Alert>}
          <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1}}>
            <Button disabled={saving} onClick={() => setColourType(null)}>CANCEL</Button>
            <Button disabled={saving} onClick={saveColour}>SAVE</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};
